import { findLast } from '@/utils/helpers';

export const makeCurrency = (val: number | string, curr: string = '₽') => `${val}\u00A0${curr}`; // nbsp

export function makeRub(value: string | number, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2) {
  const numeric = typeof value === 'number' ? value : Number(value);
  return makeCurrency(
    numeric.toLocaleString('ru-RU', {
      minimumFractionDigits: minimumFractionDigits ?? 2,
      maximumFractionDigits: maximumFractionDigits ?? 2,
    })
  );
}

const shortGroups = [
  {
    name: 'млн.',
    minValue: 1_000_000,
  },
  {
    name: 'млрд.',
    minValue: 1_000_000_000,
  },
];

export function makeCurrencyWithShortGroup(value: string | number) {
  if (value == null)
    return null;

  if (typeof value !== 'number') {
    value = Number(value);
  }

  if (!Number.isFinite(value))
    return null;

  const shortGroup = findLast(shortGroups, (item: (typeof shortGroups)[number]) => (value as number) >= item.minValue);
  if (shortGroup) {
    value /= shortGroup.minValue;
    return makeCurrency(`${value.toFixed(2).toString()} ${shortGroup.name}`);
  }

  return makeRub(value);
}
